import axios from 'axios';
import { API_BASE_URL } from '../config';

const api = axios.create({ baseURL: API_BASE_URL });

/** CRA `PUBLIC_URL` e.g. `/v3` — full browser path to login is `${PUBLIC_URL}/login` */
const PUBLIC_BASE = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const LOGIN_PATH = PUBLIC_BASE ? `${PUBLIC_BASE}/login` : '/login';

function isPublicOrCustomerPage() {
  const p = window.location.pathname;
  const prefix = PUBLIC_BASE || '';
  const customerPath = `${prefix}/customer`;
  const trackPath = `${prefix}/track`;
  return p === trackPath || p.startsWith(`${trackPath}/`) || p.startsWith(customerPath);
}

function pathnameForRedirect() {
  const { pathname, search } = window.location;
  // Store path relative to React basename so navigate() doesn’t duplicate `/v3`
  if (PUBLIC_BASE) {
    if (pathname === PUBLIC_BASE || pathname === `${PUBLIC_BASE}/`) {
      return `/${search}`;
    }
    if (pathname.startsWith(`${PUBLIC_BASE}/`)) {
      const rel = pathname.slice(PUBLIC_BASE.length) || '/';
      return `${rel}${search}`;
    }
  }
  return `${pathname}${search}`;
}

// Attach JWT on every request — check both storages (remember me uses localStorage, session-only uses sessionStorage)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      localStorage.removeItem('fmz_remember');

      const currentPath = window.location.pathname;
      const onLogin =
        currentPath === LOGIN_PATH || currentPath.startsWith(`${LOGIN_PATH}/`);

      if (!onLogin && !isPublicOrCustomerPage()) {
        const target = pathnameForRedirect();
        const redirect = encodeURIComponent(target);
        window.location.href = `${LOGIN_PATH}?redirect=${redirect}`;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
